import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ManualOrderService } from 'src/app/core/services/api-services/manual-order.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-add-order-modal',
  templateUrl: './add-order-modal.component.html',
  styleUrls: ['./add-order-modal.component.scss'],
})
export class AddOrderModalComponent implements OnInit {
  buzzerCodeDisabled: boolean = false;
  submitted = false;
  noteForm!: FormGroup;
  countryList: any[] = [];
  statlist: any[] = [];
  userId: any = '';
  constructor(
    private fb: FormBuilder,
    private manualService: ManualOrderService,
    public dialogRef: MatDialogRef<AddOrderModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public toastrService: ToastrService
  ) {
    this.userId = this.data.userId;
    // You can remove the patient_id variable as it's not being used
    //console.log('Received patient ID:', this.userId); // Use data.patientId instead of patient_id
  }

  ngOnInit(): void {
    //console.log('User ID:', this.data.userId);
    this.initializeNote();
    this.getCountryList();
  }

  onClose() {
    // This is the data to be sent back
    const result = 'Data to be sent back';
    this.dialogRef.close(result);
  }

  initializeNote() {
    this.noteForm = this.fb.group({
      country: ['', Validators.required],
      address_line_1: ['', Validators.required],
      unit: [''],
      buzzer_code: [''], // Removed Validators.required as it's being handled by checkbox
      city: ['', Validators.required],
      province: ['', Validators.required],
      postal_code: ['', Validators.required],
      delivery_instruction: [''],
      address_type: ['shipping', Validators.required],
      no_buzzer_code: [false], // Set initial value to false for checkbox
    });
  }

  submitForm() {
    this.submitted = true;

    if (this.noteForm.valid) {
      const payload = this.createPayload(this.noteForm.value);
      this.manualService.addUserAddress(payload).subscribe(
        (res) => {
          if (res?.body?.success) {
            //console.log('Address added successfully:', res);
            this.dialogRef.close();

            this.toastrService.success(res?.body?.message);
          }
        },
        (error) => {
          console.error('Error adding address:', error);
          // Handle error
        }
      );
    } else {
      console.error('Form is invalid');
      // You can handle invalid form submission here, such as displaying error messages
    }
  }

  createPayload(formData: any) {
    let selectedCountryId = formData.country;
    let selectedCountryName = '';

    // Find the country name corresponding to the selected ID
    const selectedCountry = this.countryList.find(
      (country) => country.id === selectedCountryId
    );
    if (selectedCountry) {
      selectedCountryName = selectedCountry.country_name;
    }

    let payload: any = {
      user_id: this.userId,
      address_line_1: formData.address_line_1,
      postal_code: formData.postal_code,
      address_type: formData.address_type,
      province: formData.province,
      country: selectedCountryName, // Set the country name
      city: formData.city,
      unit: formData.unit,
      delivery_instruction: formData.delivery_instruction,
      no_buzzer_code: formData.no_buzzer_code,
    };

    // Check if the buzzer code is disabled
    if (formData.no_buzzer_code) {
      // If checkbox is checked
      // Buzzer code is disabled, set it to null
      payload.buzzer_code = null;
    } else {
      // Buzzer code is enabled, set the buzzer code value
      payload.buzzer_code = formData.buzzer_code;
    }

    return payload;
  }

  getCountryList() {
    this.manualService.getCountryList({}).subscribe(
      (res) => {
        if (res?.body?.success) {
          this.countryList = res.body.data;
          //console.log('this country::', this.countryList);
          this.setInitialCountry(); // Call the function to set the initial country
          this.getStateList();

          // Extracting country names
          const countryNames = this.countryList.map(
            (country) => country.country_name
          );
          //console.log('Country Names:', countryNames);
        }
      },
      (err) => {}
    );
  }

  setInitialCountry() {
    if (this.countryList.length > 0) {
      // If country list is not empty
      const firstCountryId = this.countryList[0].id; // Get the ID of the first country
      this.noteForm.patchValue({ country: firstCountryId }); // Set the initial value of the country form control
    }
  }

  onCountrySelectionChange(countryId: any) {
    this.noteForm.patchValue({ country: countryId });
    this.getStateList(); // Call the function to fetch states for the newly selected country
  }

  getStateList() {
    const selectedCountryId = this.noteForm.get('country')?.value;
    //console.log('Selected Country ID:', selectedCountryId);
    const payload = {
      country_id: selectedCountryId,
    };
    this.manualService.getstateList(payload).subscribe(
      (res) => {
        if (res?.body?.success) {
          this.statlist = res.body.data;
          //console.log('State list:', this.statlist);
          // Whenever the state list is updated, we should set the initial state.
          this.setInitialState();
        }
      },
      (err) => {
        console.error('error::', err);
      }
    );
  }

  setInitialState() {
    if (this.statlist.length > 0) {
      // If country list is not empty
      const firstState = this.statlist[0].id; // Get the ID of the first country
      this.noteForm.patchValue({ province: firstState }); // Set the initial value of the country form control
    }
  }

  toggleBuzzerCode(event: any) {
    const checked = event.target.checked;
    if (checked) {
      this.noteForm.patchValue({ buzzer_code: null }); // Set buzzer code value to null
      this.noteForm.get('buzzer_code')!.disable(); // Disable the buzzer code input
    } else {
      this.noteForm.get('buzzer_code')!.enable(); // Enable the buzzer code input
    }
  }
}
